import { type SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isDark?: boolean;
  size?: number;
}

export default function AlternativeLogoSymbol({ isDark, size = 50, ...props }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 800 800"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M399.5 711.338C531.768 711.338 638.993 572.171 638.993 400.5C638.993 228.829 531.768 89.6621 399.5 89.6621C267.232 89.6621 160.007 228.829 160.007 400.5C160.007 572.171 267.232 711.338 399.5 711.338Z"
        fill="url(#paint0_linear_6243_5868)"
      />
      <path
        d="M399.32 413.426C416.217 413.426 429.914 357.707 429.914 288.974C429.914 220.241 416.217 164.521 399.32 164.521C382.424 164.521 368.727 220.241 368.727 288.974C368.727 357.707 382.424 413.426 399.32 413.426Z"
        fill="white"
      />
      <path
        d="M395.425 493.81C406.247 483.579 375.382 437.81 326.487 391.582C277.592 345.355 229.181 316.174 218.36 326.405C207.538 336.636 238.403 382.405 287.298 428.633C336.193 474.861 384.603 504.041 395.425 493.81Z"
        fill="white"
      />
      <path
        d="M509.303 428.633C558.198 382.405 589.063 336.636 578.241 326.405C567.419 316.174 519.009 345.355 470.114 391.582C421.219 437.81 390.354 483.579 401.176 493.81C411.998 504.041 460.407 474.861 509.303 428.633Z"
        fill="white"
      />
      <path
        d="M501.63 562.596C546.988 519.182 575.62 476.198 565.581 466.589C555.542 456.981 510.634 484.386 465.277 527.8C419.919 571.214 391.287 614.198 401.326 623.806C411.365 633.415 456.272 606.01 501.63 562.596Z"
        fill="white"
      />
      <path
        d="M297.01 562.596C251.653 519.182 223.021 476.198 233.06 466.589C243.099 456.981 288.006 484.386 333.364 527.8C378.722 571.214 407.354 614.198 397.315 623.806C387.276 633.415 342.368 606.01 297.01 562.596Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M392.971 703.849V387.146H405.753V703.849H392.971Z"
        fill="white"
      />
      <path
        d="M320.132 312.42C339.724 304.868 346.535 277.189 335.346 250.598C324.157 224.006 299.206 208.572 279.614 216.125C260.023 223.676 253.21 251.355 264.399 277.947C275.588 304.538 300.541 319.972 320.132 312.42Z"
        fill="#D3BD3F"
      />
      <path
        d="M475.342 312.42C455.75 304.868 448.939 277.189 460.127 250.598C471.317 224.006 496.268 208.572 515.86 216.125C535.451 223.676 542.264 251.355 531.074 277.947C519.886 304.538 494.933 319.972 475.342 312.42Z"
        fill="#D3BD3F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M223.708 176.157C268.161 118.463 330.221 82 399.5 82C468.779 82 530.839 118.463 575.292 176.157C619.746 233.855 647 313.197 647 400.5C647 487.803 619.746 567.145 575.292 624.842C530.839 682.537 468.779 719 399.5 719C330.221 719 268.161 682.537 223.708 624.842C179.254 567.145 152 487.803 152 400.5C152 313.197 179.254 233.855 223.708 176.157ZM236.598 185.251C194.373 240.055 168.014 316.132 168.014 400.5C168.014 484.868 194.373 560.945 236.598 615.749C278.825 670.555 336.511 703.676 399.5 703.676C462.489 703.676 520.175 670.555 562.402 615.749C604.627 560.945 630.986 484.868 630.986 400.5C630.986 316.132 604.627 240.055 562.402 185.251C520.175 130.445 462.489 97.3243 399.5 97.3243C336.511 97.3243 278.825 130.445 236.598 185.251Z"
        fill={isDark ? "#24515F" : "#24515F"}
      />
      <defs>
        <linearGradient
          id="paint0_linear_6243_5868"
          x1="399.5"
          y1="89.6621"
          x2="399.5"
          y2="711.338"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#36778B" />
          <stop offset="1" stopColor="#4E705B" />
        </linearGradient>
      </defs>
    </svg>
  );
}
